import AvailableAgentsCapacityMetric from "../available-agents-capacity-metric";
import { faComments } from "@fortawesome/pro-duotone-svg-icons";
import { FunctionComponent, memo } from "react";
import { IProps } from "./highest-agent-capacity-metric.types";
import "./highest-agent-capacity-metric.scss";

/**
 * Display the number of chats the busiest agent has currently.
 * @returns Chats metric.
 */
const HighestAgentCapacityMetric: FunctionComponent<IProps> = () => {
    return (
        <AvailableAgentsCapacityMetric
            isLoading={false}
            aggregate={(values) => Math.max(...values)}
            icon={faComments}
            title="Busiest Agent's Concurrency"
            tooltipContent="Interactions being handled by the busiest available agent"
        />
    );
};

export default memo(HighestAgentCapacityMetric);
